<template>
  <v-container fluid>
   
    <svg :height="h" :width="w"  fill="none">
      <rect width="100%" height="100%" fill="white" />
      <line
        v-for="(d,i) in hlines"
        :key="i+100"
        :x1="d.x1"
        :y1="d.y1"
        :x2="d.x2"
        :y2="d.y2"
        class="grid"
      />
      <line
        v-for="(d,i) in vlines"
        :key="i+200"
        :x1="d.x1"
        :y1="d.y1"
        :x2="d.x2"
        :y2="d.y2"
        class="grid"
      />

      <line
        v-for="(d,i) in hlines2"
        :key="i+300"
        :x1="d.x1"
        :y1="d.y1"
        :x2="d.x2"
        :y2="d.y2"
        class="grid"
      />
      <line
        v-for="(d,i) in vlines2"
        :key="i+500"
        :x1="d.x1"
        :y1="d.y1"
        :x2="d.x2"
        :y2="d.y2"
        class="grid"
        />
      

      
      <path :d="pathData" />
            <text class="ep" :x="10"  :y="35">kuvan ruudukot: harva 50x50cm ja tiheä 10x10cm</text>
            <text class="ep" :x="10"  :y="15">{{data.name}}</text>
      <text  class="ep" :x="w-250"  :y="h-10">Malli nro 123 - epyydys.web.app</text>

      <rect v-for="(d,i) in texts" :key="i+700" :x="d.x+2" :y="d.y-4-14" rx="10" ry="10" width="100" height="20" class="eptextbg"></rect>
      <text v-for="(d,i) in texts" :key="i+700" :x="d.x+4" :y="d.y-4" class="eptext">{{d.text}}</text>
      

    </svg>
  </v-container>
</template>

<script>
import * as d3 from "d3";
var _ = require("lodash");
//import debounce from 'debounce'
export default {
  name: "draw2d",
  props: ["data","coords"],
  data: () => ({
    scale: 100,
    w: 1200,
    h: 800,
    hlines: [],
    vlines: [],
    hlines2: [],
    vlines2: [],
    testi: "Testing",
    pathData: "",
    texts: []
  }),
  mounted() {


    //console.log(this.hlines);
    this.draw();
  },
  methods: {
    draw: function() {
      this.testi = "OK";

      var d = this.data.coords;

      var points = [];
      var ymin = 0
      var ymax = 0
      var xmax = 0

      for (var i = 0; i < d.length; i = i + 2) {
        points.push({ x: d[i], y: d[i + 1] })
        if( Number(d[i+1]) < ymin ) ymin = d[i+1]
        if( Number(d[i+1]) > ymax ) ymax = d[i+1]
        if( Number(d[i]) > xmax ) xmax = d[i]
        }
 
      if( ymin < 0) this.h = 2*ymax*this.scale + 150
      else this.h = ymax*this.scale + 150
      
      this.w = xmax*this.scale + 150

    // Tausta gridi
    for ( i = 0; i < this.h; i = i + 50) {
      this.hlines.push({ x1: 0, y1: i, x2: this.w, y2: i });
    }
    for (i = 0; i < this.w; i = i + 50) {
      this.vlines.push({ x1: i, y1: 0, x2: i, y2: this.h });
    }

    // Tausta verkko
    for ( i = 100 ; i < this.h -50; i = i + 5) {
      this.hlines2.push({ x1: 50, y1: i, x2: this.w-100, y2: i });
    }
    for (i = 50; i < this.w - 100 ; i = i + 5) {
      this.vlines2.push({ x1: i, y1: 100, x2: i, y2: this.h-50 });
    }


      var lineGenerator = d3
        .line()
        .x(d => d.x * this.scale + 50)
        .y(d => this.h  -( d.y - ymin )* this.scale -50 )

      this.pathData = lineGenerator(points);
      //this.pathData = points;




      for (i in points) {
        d = points;
        var x = points[i].x * this.scale + 50
        var y = this.h - (points[i].y - ymin)* this.scale - 50

        // Pyöristetään lähimpään 5cm
        var x1 = _.round(_.round(d[i].x*20)/20,2);
        var y1 = _.round(_.round(d[i].y*20)/20,2);

        if( ymin < 0 ) y1 = y1 - ymin

        var text = x1 + "m / " + y1 + "m";



        this.texts.push({ x: x, y: y, text: text });
      }

      //d3.select("path").attr("d", this.pathData);
    }
  }
};
</script>
<style scoped>
.grid {
  stroke: grey;
  stroke-width: 1;
  stroke-opacity: 1;
  shape-rendering: crispEdges;
}

path {
  stroke: black;
  stroke-width: 3;
  shape-rendering: crispEdges;
}

.ep { font: italic 14px sans-serif; fill:grey }

.eptext { fill:black }

.eptextbg { fill:lightyellow }
</style>